<template>
  <v-autocomplete
    v-bind:value="modelValue"
    :items="items"
    item-text="descricao"
    item-value="id"
    v-bind="$attrs"
    :loading="loading"
    v-on="inputListeners"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        :color="cor_loading"
        indeterminate
      ></v-progress-linear>
    </template>

    <template #prepend-item v-if="multiplaSelecao && items.length">
      <v-list-item
        v-if="modelValue.length === items.length"
        class="py-2"
        @click="updateModelValue([])"
      >
        <v-icon color="primary" class="ml-2">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
      </v-list-item>

      <v-list-item
        v-else
        class="py-2"
        @click="updateModelValue(Helpers.arrayColumn(items, 'id'))"
      >
        <v-icon v-if="modelValue.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todos</span>
      </v-list-item>

      <v-divider />
    </template>

    <template #selection="{item}" v-if="multiplaSelecao">
      <span>
        {{ item.sigla }}<template v-if="modelValue.indexOf(item.id) !== modelValue.length - 1">,&nbsp;</template>
      </span>
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-autocomplete>
</template>

<script>
import CfgAPI from "@/api/cfg"

export default {
  name: "SysGrupoAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  emits: ["change", "update:modelValue"],
  props: {
    modelValue: {
      type: [Number, String, Array],
      required: true
    },
    unshiftItems: {
      type: Object,
      default: () => ({})
    },
    cor_loading: {
      type: String,
      default: 'red'
    },
    auto_selecao_primeiro_grupo: {
      type: Boolean,
      default: false
    },
    auto_selecao_grupos: {
      type: Boolean,
      default: false
    },
    ocultar_grupos_todos: {
      type: Boolean,
      default: true,
    },
    apenas_grupos_drp: {
      type: Boolean,
      default: false,
    },
    config_compras_exibir_grupo_compras_usuario_ativo: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    value: "",
    items: [],
    loading: false
  }),
  computed: {
    inputListeners: function () {
      var vm = this

      return Object.assign({},
        this.$listeners,
        {
          input: function (event) {
            vm.updateModelValue(event)
          }
        }
      )
    },
    multiplaSelecao() {
      return ![null, undefined].includes(this.$attrs.multiple)
    }
  },
  watch: {
    items() {
      this.$emit('items', this.items);
    },
    modelValue(valor_antigo, valor_novo) {
      if (String(valor_antigo) !== String(valor_novo)) {
        this.$emit("change", {})
      }
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    updateModelValue(newValue) {
      this.$emit("update:modelValue", newValue)
    },
    getItems() {
      this.loading = true
      const headers = this.Helpers.iniciarRequisicao()

      const params = {
        filtrar_grupo_todos: this.ocultar_grupos_todos ? 'S' : 'N',
        apenas_grupos_drp: this.apenas_grupos_drp ? 'S' : 'N',
        config_compras_exibir_grupo_compras_usuario_ativo: this.config_compras_exibir_grupo_compras_usuario_ativo ? 'S' : 'N',
      };

      CfgAPI.getGrupos(headers, params)
        .then((response) => {
          const { token, grupos } = response.data
          localStorage.token = token
          // grupos.forEach(item => item.descricao = `${item.id} - ${item.descricao}`)
          this.items = grupos

          if (this.unshiftItems && this.unshiftItems.id !== undefined) {
            this.items.unshift(this.unshiftItems)
          }

          if (this.auto_selecao_grupos && this.items.length > 0) {
            const grupos_id = this.items.map(item => item.id);
            this.updateModelValue(grupos_id);
          }

          if (grupos.length > 0 && this.auto_selecao_primeiro_grupo) {
            const menor = grupos.reduce((menorAtual, item) => item.id < menorAtual.id ? item : menorAtual);
            this.updateModelValue([menor.id]);
          }

          this.loading = false;
        })
        .catch(() => this.Helpers.logout())
    }
  }
}
</script>

<style scoped>
.pl-14px {
  padding-left: 14px
}
</style>
